import React from 'react';
import ComboSelect from 'react-combo-select';


class EcoRequireAmount extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.treeCoefficient = 111;
    }


  render() {
    let co2Emissions  =this.props.co2Emissions;
    let treeRequireAmount =co2Emissions /this.treeCoefficient;

    treeRequireAmount = parseFloat(treeRequireAmount);
    treeRequireAmount = treeRequireAmount.toFixed(1);
    return (
      <div style={mainDivStyle}>
      <div style={ecoRequireAmountDivStyle}>
          총 {treeRequireAmount} 그루의 나무를 심어야 합니다.
          <p/>

      </div>
          <div style={co2ReduceAcitivyDiv}>
            2023년 기준 탄소배출권 거래금액은 1톤(t) 당 약 50,000원
            <br/>
            <br/>
            탄소 배출량 감소 활동
            <br/>
            <br/>
            # 용품 재활용 하기
            <br/>
            # 일회용품 사용 최소화
            <br/>
            # 친환경 소재로 제작한 물품 사용하기
            <br/>
            # 분리수거 하기
            <br/>
            # 나무 심기
            <br/>
            # 친환경 자동차 이용하기
            <br/>
            # 친환경 활동 지원을 위한 기부 활동
            <br/>
            <br/>
            <br/>
          </div>

        </div>
    );
  }
}


const treeCoefficient = 0;
const  ecoRequireAmountDivStyle = {
  marginTop : "50px",
  display:'flex',
  flexDirection: "column",
}

const mainDivStyle = {
  display:'flex',
  flexDirection: "column",
  justifyContent: 'center',
  alignItems:'center'
}
const co2ReduceAcitivyDiv = {
  textAlign:'left',
}
const inputDivStyle  = {
}
const inputButtonStyle={
  height:"50px",
  width:"150px",
  color:"white",
  background:"#002060"
}
const addDivStyle ={
  marginTop : "50px"
}

EcoRequireAmount.defaultProps = {
  co2Emissions:0
};

export default EcoRequireAmount;
